/*
*  A custom error that can hold a message object
*  This message object can be used to store the
*  react intl message format
* */

function createLocalizedError() {
  function LocError(message) {
    this.name = 'LocError';
    this.message = message;
  }
  LocError.prototype = new Error();
  LocError.prototype.constructor = LocError;
  return LocError;
};

export const LocalizedError = createLocalizedError();



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/localizedError.js